export default __webpack_public_path__ + "static/media/calendar.3ad1315d.svg";